import { redirect } from "react-router-dom";
import checkModules from "../../services/checkModules";

export default async function checkVerififyModules(tipoPlano) {
  try {
    const verifyModules = window?.config?.REACT_APP_VERIFY_MODULES || "";
    const modules = verifyModules === "true" ? await checkModules() : null;
    // if (verifyModules === "true") {
    //   localStorage.setItem("modulos", JSON.stringify(modules));
    // }

    if (verifyModules !== "true") {
      return null;
    }
    if (verifyModules === "true" && modules[tipoPlano]) {
      return null;
    }

    throw new Error();
  } catch {
    return redirect("/homeIn");
  }
}
